import React, { useContext } from "react"
import {
  Typography,
  Box,
  FormControl,
  Grid,
  TextField,
  useMediaQuery,
  Container,
} from "@material-ui/core"
import { Formik, Form, ErrorMessage, FieldArray, Field } from "formik"
import { useTheme } from "@material-ui/styles"
import FormErrors from "../../FormErrors"
import * as Yup from "yup"
import Paper from "../../Paper"
import { useStyles } from "./style"

import Button from "../../Button"
import { Close, Add } from "@material-ui/icons"

import LoanContext from "../../../context/loan/loanContext"
import AlertContext from "../../../context/alert/alertContext"
import SocialShare from "../../../components/SocialShare"

const ReferLayout = () => {
  const { isLoading, refer } = useContext(LoanContext)
  const { setAlert } = useContext(AlertContext)


  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  // const message = ``
  let initialValues = { message: "", userName: "", userEmail: "", friends: [{name : "", email : ""}] }

  const validationSchema = Yup.object({
    message: Yup.string().required("Message is empty"),
    userEmail: Yup.string()
      .email("Invalid email format!")
      .required("Email is empty"),
    userName: Yup.string().required("Full name is empty"),
  })

  let passed = true
  const onSubmit = async (values, resetForm) => {
    console.log("The value of the friends is: ", values);
    values.friends.forEach(friend => {
      if (friend === "" || friend.name === "" || friend.email === "") {
        passed = false
        setAlert("Please fill all fields", "error")
        return false
      }

      if (!/\S+@\S+\.\S+/.test(friend.email)) {
        passed = false
        setAlert("Avoid Invalid email format", "error")
        return false
      }
    })
    passed && (await refer(values, resetForm))
  }

  const url = 'https://bursery.com'
  const classes = useStyles()

  return (
    <Box
      id="refer"
      position="relative"
      paddingTop={isMobile ? "8rem" : "9.5rem"}
      className={classes.root}
    >
      <Box className={classes.hero}>
        <Typography variant="h2" align="center" gutterBottom>
          Referral
        </Typography>
        <Typography className={classes.subTitle} align="center">
          Invite your friends & loved ones
          to this amazing opportunity that  {!isMobile && <br />}
          Bursery offers.
        </Typography>
      </Box>
      <Box className={classes.body}>
        <Container maxWidth={"md"}>
          <Paper padding={25} borderRadius={1}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              // onSubmit={onSubmit}
              onSubmit={(initialValues, { resetForm }) => {
                onSubmit(initialValues, resetForm)
              }}
              render={({ values, getFieldProps, resetForm }) => (
                <Form style={{ paddingTop: '35px' }}>
                  <FormControl className={classes.formControl}>
                    <Typography className={classes.label}>Message</Typography>
                    <TextField
                      variant="outlined"
                      name="message"
                      id="message"
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Please enter the email of the head of your organisation. This will set this person as the highest level manager on the platform."
                      {...getFieldProps("message")}
                      size="small"
                    />
                    <ErrorMessage name="message" component={FormErrors} />
                  </FormControl>
                  <Grid
                    container
                    spacing={isMobile ? 2 : 4}
                    style={{ marginTop: "1rem" }}
                  >
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl className={classes.formControl}>
                        <Typography className={classes.label}>
                          Your Full name
                        </Typography>
                        <TextField
                          variant="outlined"
                          name="userName"
                          id="userName"
                          placeholder="Nma Okafor"
                          size="small"
                          {...getFieldProps("userName")}
                          className={classes.textField}
                        />
                        <ErrorMessage name="userName" component={FormErrors} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl className={classes.formControl}>
                        <Typography className={classes.label}>
                          Your Email
                        </Typography>
                        <TextField
                          variant="outlined"
                          size="small"
                          name="userEmail"
                          id="userEmail"
                          placeholder="example@email.com"
                          {...getFieldProps("userEmail")}
                          className={classes.textField}
                        />
                        <ErrorMessage name="userEmail" component={FormErrors} />
                      </FormControl>
                    </Grid>
                  </Grid>
                  
                  <FieldArray
                    name="friends"
                    render={arrayHelpers => (
                      <div>
                        {values.friends && values.friends.length > 0 ? (
                          <Box marginTop={1}>
                            {values.friends.map((friend, index) => (
                              <Grid
                                container
                                spacing={isMobile ? 2 : 4}
                                key={index}
                              >
                                <Grid item xs={12} sm={12} md={6}>
                                  <FormControl className={classes.formControl}>
                                    <Typography className={classes.label}>
                                      Recipient’s Full Name
                                    </Typography>

                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      name={`friends[${index}].name`}
                                      placeholder="Nma okafor"
                                      className={classes.textField}
                                      {...getFieldProps(`friends[${index}].name`)}
                                    />
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                  <FormControl className={classes.formControl}>
                                    <Typography className={classes.label}>
                                      Recipient’s Email Address
                                    </Typography>
                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      name={`friends[${index}].email`}
                                      className={classes.textField}
                                      placeholder="admin@uberng.com"
                                      {...getFieldProps(`friends[${index}].email`)}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            ))}
                            <Box marginTop={2}>
                              {/* <Typography
                                display="inline"
                                variant="body2"
                                color="primary"
                                style={{
                                  fontSize: "12px",
                                  marginTop: "0.5rem",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  arrayHelpers.push({ name: "", email: "" })
                                }
                              >
                                <Add style={{ fontSize: "0.8rem" }} /> Add
                                another friend
                              </Typography> */}
                              {values.friends.length > 1 && (
                                <Typography
                                  display="inline"
                                  variant="body2"
                                  color="primary"
                                  style={{
                                    fontSize: "12px",
                                    marginLeft: "1rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => arrayHelpers.remove(values.friends.length - 1)}
                                >
                                  {/* arrayHelpers.remove() */}
                                  <Close style={{ fontSize: "0.8rem" }} />{" "}
                                  Remove friend
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              console.log(values)
                              arrayHelpers.push({ name: "", email: "" })
                            }

                            }
                          >
                            Add a friend
                          </button>
                        )}
                        <Box marginTop={3} className={classes.action}>
                          {/* <Typography
                            style={{ fontWeight: "600", marginRight: "1rem", cursor: "pointer" }}
                            onClick={() =>
                              resetForm({
                                initialValues: {
                                  message,
                                  userName: "",
                                  userEmail: "",
                                  friends: [""],
                                },
                              })
                            }
                          >
                            Cancel
                          </Typography> */}

                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={isLoading}
                            loading={isLoading}
                          >
                            Send Invite
                          </Button>
                        </Box>
                      </div>
                    )}
                  />
                </Form>
              )}
            />
            <Box marginTop={5} marginBottom={5}>
              <SocialShare shareUrl={url} />
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  )
}

export default ReferLayout
